var map = {
	"./da_DK.json": 38050,
	"./de.json": 30648,
	"./en.json": 95441,
	"./es.json": 43716,
	"./hu.json": 80427,
	"./lt.json": 51574,
	"./pl.json": 95218,
	"./pt.json": 97550,
	"./ro.json": 63902,
	"./sk.json": 25518,
	"./sv.json": 70499,
	"./uk.json": 49472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40955;